// Consignment or outright, for one item (Zsolt, 2026-09-30).
//
// Offer consignment when BP is over £1000: that much cash is never tied up in one
// item. A £1000+ SP item with BP up to £1000 is bought outright only when the
// engine's market read is strong enough to trust the price. A weak read means
// an unconfirmed identity under 90%, a price spread over 30%, or fewer than 5
// sold comps. A confirmed identity (signals.identity_confirmed, from
// kgConfirmsIdentity) is never weak, whatever the engine's score (2026-10-01).
//
// This replaced the SP-band gate (slow-selling type, condition below Good, offer
// below floor−4pp), which offered consignment on items the owner would buy.
//
// signals: the engine read from mergeItemSignals ({ ic_score, volatility_pct,
// demand_tier, ... }) plus identity_confirmed, or null when the item has none
// (unpriced, parked).

const BP_CEILING_CENTS = 100000;
const MIN_IDENTITY_SCORE = 0.90;
const MAX_SPREAD_PCT = 30;
// HIGH means 5 or more sold comps, HIGH11PLUS 11 or more (EngineReadBlock DEMAND_TIP).
const ENOUGH_SOLD_TIERS = new Set(['HIGH11PLUS', 'HIGH']);

// Returns null (no path applies), or { path: 'consign' | 'outright', reasons }.
export function decideConsignment({ spCents, bpCents, spInTopBand, signals }) {
    const reasons = [];
    if (bpCents != null && bpCents > BP_CEILING_CENTS) reasons.push('BP over £1000');
    if (spInTopBand) reasons.push(...weakReadReasons(signals));
    if (reasons.length) return { path: 'consign', reasons };
    return spInTopBand ? { path: 'outright', reasons } : null;
}

function weakReadReasons(signals) {
    if (!signals) return ['no market read'];
    const reasons = [];
    if (!signals.identity_confirmed) {
        if (typeof signals.ic_score !== 'number') reasons.push('identity unknown');
        else if (signals.ic_score < MIN_IDENTITY_SCORE) reasons.push('identity under 90%');
    }
    if (typeof signals.volatility_pct === 'number' && signals.volatility_pct > MAX_SPREAD_PCT) {
        reasons.push('price spread over 30%');
    }
    if (!ENOUGH_SOLD_TIERS.has(signals.demand_tier)) reasons.push('fewer than 5 sold comps');
    return reasons;
}
